import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/site";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [paused]);

  const slide = heroSlides[active];

  return (
    <section
      aria-label="精选内容轮播"
      className="relative w-full overflow-hidden bg-foreground-950"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="relative h-[440px] w-full sm:h-[500px] md:h-[560px]">
        {heroSlides.map((item, index) => (
          <img
            key={item.id}
            src={item.image}
            alt={`${item.title}的氛围插图`}
            title={`${item.title} - 挠脚心网站精选`}
            className={`absolute inset-0 h-full w-full object-cover object-top transition-opacity duration-700 ${
              index === active ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/55 to-foreground-950/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/20"></div>

        <div className="relative mx-auto flex h-full w-full max-w-[1240px] flex-col justify-center px-4 py-10 md:px-6">
          <div key={slide.id} className="max-w-xl animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1 text-[11px] font-medium text-foreground-950">
              <i className="ri-sparkling-2-line text-xs"></i>
              {slide.kicker}
            </span>
            <h1 className="mt-4 font-heading text-3xl leading-tight text-background-50 sm:text-4xl md:text-5xl">
              {slide.title}
            </h1>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-200/90 md:text-base">
              {slide.description}
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to={slide.to}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-400"
              >
                {slide.cta}
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
              <Link
                to="/videos"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-5 py-3 text-sm text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-play-circle-line text-base"></i>
                全部视频
              </Link>
            </div>
          </div>

          <div className="mt-8 flex items-center gap-4 md:mt-10">
            <div className="flex items-center gap-2">
              {heroSlides.map((item, index) => (
                <button
                  key={item.id}
                  type="button"
                  aria-label={`查看第 ${index + 1} 个精选内容`}
                  onClick={() => setActive(index)}
                  className={`h-1.5 cursor-pointer rounded-full transition-all ${
                    index === active ? "w-8 bg-primary-400" : "w-3 bg-background-50/40 hover:bg-background-50/70"
                  }`}
                />
              ))}
            </div>
            <span className="text-xs text-background-200/70">
              {String(active + 1).padStart(2, "0")} / {String(heroSlides.length).padStart(2, "0")}
            </span>
            <div className="ml-auto hidden items-center gap-2 sm:flex">
              <button
                type="button"
                aria-label="上一个精选内容"
                onClick={() => setActive((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors hover:bg-background-50/15"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                type="button"
                aria-label="下一个精选内容"
                onClick={() => setActive((prev) => (prev + 1) % heroSlides.length)}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-50/30 text-background-50 transition-colors hover:bg-background-50/15"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}